import React, { PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import { Relayout, RelayoutItem } from 'relayout'

import PrimaryButton from 'components/primary-button'
import PromoCodeListItem from './promo-code-list-item'
import PromoCodeListEmpty from './promo-code-list-empty'

import styles from './promo-code-list.css'


const PromoCodeList = ({ listOfCodes }) => (
  <div styleName="promo-code-list">

    <Relayout>
      <RelayoutItem sm="12" lg="9">
        <h1 styleName="title">Promo Codes</h1>
      </RelayoutItem>
      <RelayoutItem sm="12" lg="3">
        <div styleName="add-button">
          <PrimaryButton label="ADD" />
        </div>
      </RelayoutItem>
    </Relayout>

    <div styleName="list">
      <div styleName="header">
        <Relayout>
          <RelayoutItem sm="12" lg="3">
            <div styleName="label">Promo code</div>
          </RelayoutItem>
          <RelayoutItem sm="12" lg="2">
            <div styleName="label">Discount</div>
          </RelayoutItem>
          <RelayoutItem sm="12" lg="4">
            <div styleName="label">Valid</div>
          </RelayoutItem>
          <RelayoutItem sm="12" lg="3">
            <div styleName="label">Can be used</div>
          </RelayoutItem>
        </Relayout>
      </div>
      <div styleName="body">
        {listOfCodes.length > 0 ? (listOfCodes.map(
          code => <PromoCodeListItem key={code.id} code={code} />
        )) : <PromoCodeListEmpty />}
      </div>
    </div>
  </div>
)

PromoCodeList.propTypes = {
  listOfCodes: PropTypes.array,
}

export default CSSModules(PromoCodeList, styles)



/** WEBPACK FOOTER **
 ** ./src/components/promo-code-list/promo-code-list.js
 **/